import type { ProductBaseGtm } from '../../../types/productBaseGtm'
import { BbkCustomerDataLayer } from '../../../graphql/types/graphql'

export function useGtmSearch() {
    const searchEventsInGtm = async (currentStore: string, customerData: BbkCustomerDataLayer, gaCookie: string) => {
        const { isUserLoggedIn } = useUser()

        useGtm()?.trackEvent({
            event: 'interaction',
            currentStore,
            customerData,
            _ga: gaCookie || '',
        })

        useGtm()?.trackEvent({
            event: 'fireRemarketingTag',
            'google_tag_params.ecomm_pagetype': 'searchresults',
            'google_tag_params.returnCustomer': await isUserLoggedIn(),
        })
    }

    const searchProduct = async (products: ProductBaseGtm[]) => {
        useGtm()?.trackEvent({
            event: 'productsLoaded',
            ecommerce: {
                impressions: products,
            },
        })
    }

    const searchProductUpdated = async (products: ProductBaseGtm[]) => {
        useGtm()?.trackEvent({
            event: 'productsUpdated',
            ecommerce: {
                impressions: products,
            },
        })
    }

    return {
        searchEventsInGtm,
        searchProduct,
        searchProductUpdated,
    }
}
